import { t } from '../../../../../services/texts.service';
import { IconColor } from '../../../../Shared/Icon/icon-color.enum';
import { IconMotif } from '../../../../Shared/Icon/icon-motif.enum';
import { IconVariant } from '../../../../Shared/Icon/icon-variant.enum';

export class SeverityAndTitleFactHelper {
  public static getSeverityIcon(severity: string): { iconMotif: IconMotif; iconColor: IconColor; iconVariant?: IconVariant } {
    switch (severity) {
      case 'severe':
        return { iconMotif: IconMotif.Exclamation, iconColor: IconColor.Red600, iconVariant: IconVariant.HexagonFilled };
      case 'normal':
        return { iconMotif: IconMotif.Exclamation, iconColor: IconColor.Orange500, iconVariant: IconVariant.TriangleFilled };
      case 'slight':
        return { iconMotif: IconMotif.Info, iconColor: IconColor.Blue800, iconVariant: IconVariant.CircleFilled };
      default:
        return { iconMotif: IconMotif.Info, iconColor: IconColor.Blue800, iconVariant: IconVariant.CircleFilled };
    }
  }

  public static getSeverityIconAltText(severity: string): string {
    switch (severity) {
      case 'severe':
        return t('Stor påverkan', 'Severe impact');
      case 'normal':
        return t('Medelstor påverkan', 'Moderate impact');
      case 'slight':
        return t('Liten påverkan', 'Slight impact');
      default:
        return t('Medelstor påverkan', 'Moderate impact');
    }
  }
}
